import { render, staticRenderFns } from "./ChatRecodSearchContentComp.vue?vue&type=template&id=f3364cf6&"
import script from "./ChatRecodSearchContentComp.vue?vue&type=script&lang=js&"
export * from "./ChatRecodSearchContentComp.vue?vue&type=script&lang=js&"
import style0 from "./ChatRecodSearchContentComp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports